/**
 * Owner: Haselton Baker Risk Group, LLC
 * Copyright All Rights Reserved
 */

import { connect } from 'react-redux';
import {
  addChatMessage,
  clearChatHistory,
  fetchChatHistory,
  uploadFileForAgent,
  completeMultipartUpload,
} from '#actions/models/agentChat.js';
import { fetchModel } from '#actions/models/model.js';
import AiAssistantSection from './AiAssistantSection.jsx';

const mapStateToProps = (state, ownProps) => {
  const entry = state.ui.agentChat[ownProps.modelId];
  return {
    messages: entry?.messages || [],
    generation: entry?.generation ?? null,
  };
};

const mapDispatchToProps = dispatch => ({
  uploadFile: (modelId, fileName, mediaType, fileSize) =>
    dispatch(uploadFileForAgent(modelId, fileName, mediaType, fileSize)),
  completeUpload: (modelId, fileKey, s3UploadId, parts) =>
    dispatch(completeMultipartUpload(modelId, fileKey, s3UploadId, parts)),
  addMessage: (modelId, message) => dispatch(addChatMessage(modelId, message)),
  clearHistory: (modelId, generation) => dispatch(clearChatHistory(modelId, generation)),
  loadHistory: modelId => dispatch(fetchChatHistory(modelId)),
  refreshModel: modelId => dispatch(fetchModel(modelId)),
});

export default connect(mapStateToProps, mapDispatchToProps)(AiAssistantSection);
